import React, { FC } from 'react';

import Typography from '@material-ui/core/Typography';
import { fade } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';
import { Link } from 'react-router-dom';

import { IKImage } from '../../../../components/IKImage';
import { PathwayLogo } from '../../../../components/TestResults';
import { colorsPalette } from '../../../../theme';
import CourseTags from '../../../CourcesListPage/components/TagsList/TagsList';
import useStyles from './styles';

interface IMetaInfo {
  pathways?: string | null;
  learning_hours?: string | null;
  experts?: string | null;
  cpd_credits?: string | null;
}

interface CourseCardProps {
  circleImageUrl?: string | null;
  logoSvg?: string | null;
  image: string;
  title?: string | null;
  description?: string | null;
  link: string;
  meta?: IMetaInfo | null;
  progress?: number;
}

const CourseCardWide: FC<CourseCardProps> = ({
  circleImageUrl,
  logoSvg,
  image,
  title,
  description,
  link,
  meta,
}) => {
  const classes = useStyles();

  return (
    <CardWrapper to={link}>
      <ImageWrapper>
        <IKImage path={image} srcset={[{ width: 500 }]} sizes="500px" />
      </ImageWrapper>
      <Content>
        <Row>
          <PathwayLogo
            wrapperClass={classes.cardIcon}
            circleUrl={circleImageUrl}
            svgContent={logoSvg}
          />
          <Title variant="h2">{title}</Title>
        </Row>
        <Description>{description}</Description>
        <Divider />
        <CourseTags
          CPD={meta?.cpd_credits}
          hours={meta?.learning_hours}
          experts={meta?.experts}
          pathways={meta?.pathways}
        />
      </Content>
    </CardWrapper>
  );
};

export default CourseCardWide;

const Content = styled('div')({
  width: 'calc(100% - 380px)',
  padding: '36px 32px',
});
const CardWrapper = styled(Link)({
  display: 'flex',
  width: '100%',
  minHeight: 300,
  borderRadius: 8,
  color: colorsPalette.white,
  background: colorsPalette.blueDark,
  boxShadow: `0px 3px 6px ${fade(colorsPalette.black, 0.4)}`,
  '&:not(:last-child)': {
    marginBottom: 24,
  },
});
const ImageWrapper = styled('div')({
  flexBasis: 380,
  background: colorsPalette.blackSecondary,
  '& img': {
    width: '100%',
    height: '100%',
    borderRadius: '8px 0 0 8px',
    objectFit: 'cover',
  },
});
const Description = styled(Typography)({
  display: '-webkit-box',
  maxHeight: 80,
  fontSize: 18,
  color: colorsPalette.gray,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
});
const Divider = styled('div')({
  width: '100%',
  height: 1,
  marginTop: 36,
  marginBottom: 24,
  background: fade(colorsPalette.white, 0.3),
});
const Title = styled(Typography)({});
const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 18,
});
